import React from "react";

const AddSurveyIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51.038"
      height="47.979"
      viewBox="0 0 51.038 47.979"
    >
      <g
        id="Group_1153"
        data-name="Group 1153"
        transform="translate(-2.5 -5.3)"
      >
        <path
          id="Path_1232"
          data-name="Path 1232"
          d="M27.8,19.016H48.033a1.557,1.557,0,0,0,1.556-1.556v-8.1A1.557,1.557,0,0,0,48.033,7.8H27.8a8.679,8.679,0,0,1,2.093,5.635A8.266,8.266,0,0,1,27.8,19.016Z"
          transform="translate(-11.722 -1.158)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1233"
          data-name="Path 1233"
          d="M9.477,19.253A6.977,6.977,0,1,0,2.5,12.277,6.963,6.963,0,0,0,9.477,19.253ZM11.57,15.5a1.134,1.134,0,0,1-1.127-1.127,1.127,1.127,0,0,1,2.254,0A1.134,1.134,0,0,1,11.57,15.5ZM7.384,9A1.134,1.134,0,0,1,8.511,10.13a1.171,1.171,0,0,1-1.127,1.127A1.127,1.127,0,1,1,7.384,9Zm-.912,5.259,5.045-5.045a.751.751,0,0,1,1.288.537.689.689,0,0,1-.215.537L7.545,15.336a.689.689,0,0,1-.537.215.734.734,0,0,1-.751-.751A.622.622,0,0,1,6.471,14.262Z"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1234"
          data-name="Path 1234"
          d="M63.7,39.5H27.9a8.632,8.632,0,0,1,0,11.27H63.75a1.557,1.557,0,0,0,1.556-1.556V41.056A1.641,1.641,0,0,0,63.7,39.5Z"
          transform="translate(-11.769 -15.846)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1235"
          data-name="Path 1235"
          d="M55.914,71.3H27.9a8.632,8.632,0,0,1,0,11.27H55.968a1.557,1.557,0,0,0,1.556-1.556V72.856A1.6,1.6,0,0,0,55.914,71.3Z"
          transform="translate(-11.769 -30.58)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1236"
          data-name="Path 1236"
          d="M9.477,50.953A6.977,6.977,0,1,0,2.5,43.977,6.963,6.963,0,0,0,9.477,50.953Zm2.093-3.7a1.134,1.134,0,0,1-1.127-1.127,1.127,1.127,0,0,1,2.254,0A1.134,1.134,0,0,1,11.57,47.25ZM7.384,40.7A1.134,1.134,0,0,1,8.511,41.83a1.171,1.171,0,0,1-1.127,1.127,1.127,1.127,0,1,1,0-2.254Zm-.912,5.259,5.045-5.045a.759.759,0,0,1,1.073,1.073L7.545,47.036a.689.689,0,0,1-.537.215.759.759,0,0,1-.537-1.288Z"
          transform="translate(0 -14.687)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1237"
          data-name="Path 1237"
          d="M9.477,68.7a6.977,6.977,0,1,0,6.977,6.977A6.963,6.963,0,0,0,9.477,68.7ZM7.384,72.457a1.127,1.127,0,1,1-1.127,1.127A1.134,1.134,0,0,1,7.384,72.457ZM11.57,78.95a1.127,1.127,0,1,1,0-2.254A1.171,1.171,0,0,1,12.7,77.823,1.1,1.1,0,0,1,11.57,78.95Zm.966-5.259L7.491,78.736a.689.689,0,0,1-.537.215.759.759,0,0,1-.537-1.288l5.045-5.045a.751.751,0,0,1,1.288.537A.82.82,0,0,1,12.536,73.691Z"
          transform="translate(0 -29.375)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};

export default AddSurveyIcon;
